import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppAnalysisService } from 'src/app/app-analysis-module/app-analysis.service';
import { ExportLayerPricingModalComponent } from '../app-analysis-module/export-layer-pricing-modal/export-layer-pricing-modal.component';
// import { NotificationMessageComponent } from '../common-module/notification-message/notification-message.component';
import { IsochroneService } from '../isochrone-module/isochrone.service';
@Injectable({
  providedIn: 'root'
})
export class CsvFileDownloadService {

  constructor(private AppAnalysisService:AppAnalysisService,private _isochroneService: IsochroneService,private matDialog: MatDialog,public snackBar: MatSnackBar) { }


   // JSON.parse call this data function and get response parsed
   createDownloadableCsvFromGeojson(response){
 
    let csv_name='export.csv';
    let sampledata = [];
    for(var m=0;m<response.length;m++)
    {
        sampledata.push(response[m]);
    }
    var csvData=this.downloadCSV({ filename: csv_name,SampleData:sampledata });
    if(csvData)
    {
        let filename = csv_name || 'export.csv';
    let dwldLink = document.createElement("a");
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute('href', csvData);
        dwldLink.setAttribute('download', filename);
        dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    }else{
        
    }
}

 downloadCSV(args) {
  let data;
  let csv = this.convertArrayOfObjectsToCSV({
      data: args.SampleData
  });
  if (csv == null) return;

  if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
  }
  data = encodeURI(csv);
  return data;
}

convertArrayOfObjectsToCSV(data) {

    const csvRows = [];

    /* Get headers as every csv data format 
    has header (head means column name)
    so objects key is nothing but column name 
    for csv data using Object.key() function.
    We fetch key of object as column name for 
    csv */
    const headers = Object.keys(data.data[0][0]);

    /* Using push() method we push fetched 
       data into csvRows[] array */
    // csvRows.push(headers.join(','));

    // Loop to get value of each objects key
    for (const row of data.data) {
        const values = headers.map(header => {
            const val = row[header]
            return `"${val}"`;
        });

        // To add, sepearater between each value
        csvRows.push(values.join(','));
    }

    /* To add new line for each objects values
       and this return statement array csvRows
       to this function.*/
    return csvRows.join('\n');
};




// convertArrayOfObjectsToCSV(args) {
//   let result, ctr, keys, columnDelimiter, lineDelimiter, data;

//   data = args.data || null;
//   if (data == null || !data.length)
//   {
//       return null;
//   }

//   columnDelimiter = args.columnDelimiter || ',';
//   lineDelimiter = args.lineDelimiter || '\n';

//   keys = Object.keys(data[0]).sort();
  
//   result = '';
//   result += keys.join(columnDelimiter);
//   result += lineDelimiter;

//   data.forEach(function(item) {
//       ctr = 0;
//       keys.forEach(function(key) {
//          if (ctr > 0) result += columnDelimiter;
//          let cats=item[key];
//          if(typeof cats=='string')
//          {
//              if(cats.indexOf(',') !== -1)
//              {
//                  cats=cats.replace(/,/g , ":");
//              }
//          }
//           result += cats;
//           ctr++;
//       });
//       result += lineDelimiter;
//   });

//   return result;
// }
//   downloadFile(data, filename='data') {
//     let csvData = this.ConvertToCSV(data, ['property_name','property_values']);
//     console.log(csvData)
//     let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
//     let dwldLink = document.createElement("a");
//     let url = URL.createObjectURL(blob);
//     let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
//     if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
//         dwldLink.setAttribute("target", "_blank");
//     }
//     dwldLink.setAttribute("href", url);
//     dwldLink.setAttribute("download", filename + ".csv");
//     dwldLink.style.visibility = "hidden";
//     document.body.appendChild(dwldLink);
//     dwldLink.click();
//     document.body.removeChild(dwldLink);
// }

// ConvertToCSV(objArray, headerList) {
//      let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
//      let str = '';
//      let row = 'S.No,';

//      for (let index in headerList) {
//          row += headerList[index] + ',';
//      }    
//      row = row.slice(0, -1);
//      str += row + '\r\n';
//      for (let i = 0; i < array.length; i++) {
//          let line = (i+1)+'';
//          for (let index in headerList) {
//             let head = headerList[index];

//              line += ',' + array[i][head];
//          }
//          str += line + '\r\n';
//      }
//      return str;
//  }

downloadCSV1(data) {
  let data2;
  let csv = this.convertArrayOfObjectsToCSV1({
      data
  });
  if (csv == null) return;

  if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
  }
  var link
  data2 = encodeURI(csv);
  // data = encodeURI(csv);
  link = document.createElement('a');
  link.setAttribute('href', data2);
  link.setAttribute('download', 'export');
  link.click();
  return data;
}

convertArrayOfObjectsToCSV1(data) {

  const csvRows = [];

  /* Get headers as every csv data format 
  has header (head means column name)
  so objects key is nothing but column name 
  for csv data using Object.key() function.
  We fetch key of object as column name for 
  csv */
  const headers = Object.keys(data.data[0]);

  /* Using push() method we push fetched 
     data into csvRows[] array */
  csvRows.push(headers.join(','));

  // Loop to get value of each objects key
  for (const row of data.data) {
      const values = headers.map(header => {
          const val = row[header]
          return `"${val}"`;
      });

      // To add, sepearater between each value
      csvRows.push(values.join(','));
  }

  /* To add new line for each objects values
     and this return statement array csvRows
     to this function.*/
  return csvRows.join('\n');
};
  
finalDownloadGisDataFile(layerId,selectedExt,gis_data,mapid,buttonLoader,moduleName){
    console.log(layerId)
    // let gis_data = 1;
    buttonLoader = true;
    this.AppAnalysisService.exportLayer(layerId,selectedExt,gis_data).subscribe(data=>{
      console.log('--------------------------- gis layer downloaded --------->',data);
      let exportLayerid = data.data;
    buttonLoader = false;
      if(data && data.data && data.data.price =="Limit Exceeded" || data.data.price == "Premium Layer Restriction"){
        // if data is false then open pricing dailog box and make payment & download file
        let message = "Your free download is exhausted. Please purchase a plan to download the layer";
        
        if(data.data.price == "Premium Layer Restriction"){
          message = "Premium data is restricted to be downloaded from a free account. Purchase one of the following plans to access this data"
        }
        // const dialogRef = this.matDialog.open(ExportLayerPricingModalComponent,{
        //   // width: '100%',
        //     data:{'message':message,module:moduleName}
        //   });
        //   dialogRef.afterClosed().subscribe(result=>{
        //     if(result){
        //      this.AppAnalysisService.downloadExportLayer(exportLayerid,gis_data)
        //     }
        //   });
          mapid = null
      }else {
        let newWin = window.open(exportLayerid)
        if(!newWin || newWin.closed || typeof newWin.closed=='undefined'){
           this._isochroneService.openSnackBar("Please Allow Browser Pop Up","snackbar-error","fail")
        mapid = undefined
        }
        else{
          this._isochroneService.openSnackBar("Layer Downloaded Successfully","snackbar-success","success")
        //   this.stepper.selected.completed = true;
        //   this.stepper.next()
    mapid = undefined
        
        }
      }
    },err =>{ 
    buttonLoader = false; 
    });
    console.warn(layerId)
    
   
}

 


}


